import * as types from './mutation-types'
import { DISPLAY_TYPE_MAP } from '@/constants'

export default {
  [types.SET_USER](state, { id, name, picture }) {
    state.user = {
      id: id,
      name: name,
      picture: picture
    }
  },

  // devices
  [types.SET_DEVICES](state, data) {
    state.devices = data
  },
  [types.ADD_DEVICES](state, data) {
    state.devices.push(data)
  },
  [types.UPDATE_DEVICE](state, { index, data }) {
    state.devices.splice(index, 1, data)
  },

  // infodevice
  [types.SET_INFO_DEVICE_ID](state, id) {
    state.infoDeviceId = id
  },

  [types.UPDATE_RELOAD_MAP](state, isReload) {
    state.reloadMap = isReload
  },

  [types.SET_PROVIDER](
    state,
    {
      oidc_provider_name,
      idp_identifier,
      display_type,
      group_id,
      group_name,
      group_line_official_account_name
    }
  ) {
    state.provider = {
      oidcProviderName: oidc_provider_name,
      idpIdentifier: idp_identifier,
      displayType: display_type || DISPLAY_TYPE_MAP,
      groupId: group_id,
      groupName: group_name,
      groupLineOfficialAccountName: group_line_official_account_name
    }
  }
}
